import { render } from "./HeaderTitle.vue?vue&type=template&id=92a14194&scoped=true&bindings={\"title\":\"props\",\"centered\":\"props\"}"
import script from "./HeaderTitle.vue?vue&type=script&lang=js"
export * from "./HeaderTitle.vue?vue&type=script&lang=js"

import "./HeaderTitle.vue?vue&type=style&index=0&id=92a14194&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-92a14194"

export default script